import React from 'react';
import { Divider, Typography } from 'antd';
import picture01 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture01.jpg';
import picture02 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture02.jpg';
import picture03 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture03.jpg';
import picture04 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture04.jpg';
import picture05 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture05.jpg';
import picture06 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture06.jpg';
import picture07 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture07.jpg';
import picture08 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture08.jpg';
import picture09 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture09.jpg';
import picture10 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture10.png';
import picture11 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture11.jpg';
import picture12 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture12.jpg';
import picture13 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture13.jpg';
import picture14 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture14.jpg';
import picture15 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture15.jpg';
import picture16 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture16.png';
import picture17 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture17.jpg';
import picture18 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture18.png';
import picture20 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture20.jpg';
import picture21 from '../../../Assets/ResearchLabs/RSGCRL/Team/Picture21.jpg';

const { Title } = Typography;

const members = [
  ['Dr. Zia-ul-Haq', picture01],
  ['Prof. Dr. Syeda Adila Batool', picture02],
  ['Dr. Asim Daud Rana', picture03],
  ['Dr. Khalid Mahmood', picture04],
  ['Dr. Shahid Parvez', picture05],
  ['Dr. Salman Tariq', picture06],
  ['Mr. Ammar Hameed', picture07],
  ['Ms. Ushna Bint-e-Ishfaq', picture08],
  ['Ms. Ayesha Azhar', picture09],
  ['Ms. Ayesha Mariam', picture10],
  ['Dr. Syed Muhammad Irteza', picture11],
  ['Mr. Usman Mehmood', picture12],
  ['Ms. Fiza Faizi', picture13],
  ['Ms. Zartasha Ramzan', picture14],
  ['Mr. Fazzal Qayyum', picture15],
  ['Mr. Hassan Nawaz', picture16],
  ['Ms. Iqra Basit', picture17],
  ['Mr. Shafqat Ali', picture18],
  ['Ms. Rida Batool', picture20],
  ['Ms. Tehreem Mustansar', picture21],
  ['Ms. Fizza Hafeez', picture14],
  ['Ms. Hafsa Shazad', picture14],
];

const OurTeam = () => (
  <section className="sarl-team-section rsgcrl-team-section" aria-labelledby="rsgcrl-team-title">
    <div className="sarl-team-inner">
      <Title level={2} id="rsgcrl-team-title" className="sarl-team-title">Our Team</Title>
      <Divider className="ncgsa-divider" />
      <div className="sarl-team-grid rsgcrl-team-grid">
        {members.map(([name, photo], index) => (
          <article className="sarl-team-member rsgcrl-team-member" key={`${name}-${index}`}>
            <img className="sarl-team-photo rsgcrl-team-photo" src={photo} alt={name} loading="lazy" />
            <h3>{name}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default OurTeam;
